import { useContext, useRef } from "react";
import { CompanyContext } from "@/components/CompanyList/CompanyContext";
import * as constants from "@/config/constants";
import { getIsNotUserFiltered } from "@/selectors";
import { useSelector } from "react-redux";
import { Transition } from "react-transition-group";

import { ServiceFlagTrophyIcon } from "../../../../besteducation/assets/ServiceFlagTrophyIcon";
import { CheckIcon } from "../../../../client/assets/icons/common/CheckIcon";
import {
	GiftBoxIcon,
	GiftBoxIconSecondary,
} from "../../../../client/assets/icons/common/GiftBoxIcon";
import { RightArrowIcon } from "../../../../client/assets/icons/common/RightArrowIcon";
import { BaseBenefitsList } from "../../../../components/BaseComponents/BaseBenefitsList";
import { BaseCompanyLogo } from "../../../../components/BaseComponents/BaseCompanyLogo";
import { BaseFeaturedCompanyHeader } from "../../../../components/BaseComponents/BaseFeaturedCompanyHeader";
import BaseGridRatingHorizontal from "../../../../components/BaseComponents/BaseGridRatingHorizontal";
import BaseLinkWrapper from "../../../../components/BaseComponents/BaseLinkWrapper";
import BaseProductDescription from "../../../../components/BaseComponents/BaseProductDescription";
import { BasePromotionText } from "../../../../components/BaseComponents/BasePromotionText";
import BaseServiceFlag from "../../../../components/BaseComponents/BaseServiceFlag";
import { BaseSocialProof } from "../../../../components/BaseComponents/BaseSocialProof";
import { BaseVisitLink } from "../../../../components/BaseComponents/BaseVisitLink";
import { getStyles } from "./styles";

export const IncorporationServicesCompany = () => {
	const { company, companyIndex, isFeaturedCompany } =
		useContext(CompanyContext);
	const { isNotUserFiltered } = useSelector(getIsNotUserFiltered);
	const styles = getStyles({ isFeatured: isFeaturedCompany, companyIndex });
	const nodeRef = useRef(null);

	return (
		<Transition
			nodeRef={nodeRef}
			in
			appear={!isNotUserFiltered}
			timeout={constants.FILTERING_TRANSITION_DURATION}
			unmountOnExit
		>
			<BaseLinkWrapper
				className={`tw:mb-6 tw:block tw:rounded-lg tw:bg-white tw:shadow-[0px_4px_24px_0px_rgba(88,102,126,0.06),0px_1px_2px_0px_rgba(88,102,126,0.12)] tw:transition tw:hover:shadow-[0px_8px_32px_0px_rgba(0,0,0,0.08),0px_2px_20px_0px_rgba(0,0,0,0.04)] ${
					isFeaturedCompany ? "tw:ring-1 tw:ring-[#359492]" : ""
				}`}
			>
				<BaseFeaturedCompanyHeader {...styles.featuredCompanyHeader} />

				<div className="tw:relative">
					<BaseServiceFlag
						classNames={styles.serviceFlag}
						icon={
							<ServiceFlagTrophyIcon className="tw:h-3 tw:w-3.5 tw:lg:size-4" />
						}
					/>

					<div className="tw:mx-auto tw:flex tw:max-w-[400px] tw:flex-col tw:gap-4 tw:p-4 tw:pt-14 tw:pb-4 tw:lg:max-w-none tw:lg:flex-row tw:lg:gap-0 tw:lg:pt-4 tw:lg:pl-16 tw:xl:py-6 tw:xl:pr-6">
						<div className="tw:flex tw:shrink-0 tw:justify-center tw:lg:w-[204px] tw:lg:pr-3 tw:xl:w-[260px]">
							<div className="tw:flex tw:w-full tw:flex-row tw:flex-wrap tw:items-center tw:justify-center tw:gap-4 tw:lg:flex-col">
								<BaseCompanyLogo classNames={styles.companyLogo} />
								<BaseGridRatingHorizontal classNames={styles.rating} />
							</div>
						</div>

						<div className="tw:flex tw:grow tw:flex-col tw:lg:max-w-none tw:lg:px-3">
							<div className="tw:flex tw:w-full tw:flex-col">
								<BaseProductDescription className={styles.productDescription} />
								<BaseBenefitsList
									{...styles.benefitsList}
									icon={<CheckIcon className="tw:text-base tw:sm:mt-1" />}
								/>
							</div>
						</div>

						<div className="tw:flex tw:flex-col tw:justify-center tw:lg:max-w-none tw:lg:px-3">
							<div className="tw:flex tw:h-[132px] tw:w-full tw:flex-col tw:lg:h-[160px] tw:lg:w-[160px]">
								<BasePromotionText
									{...styles.coupon}
									icon={
										companyIndex === 0 ? (
											<GiftBoxIcon />
										) : (
											<GiftBoxIconSecondary />
										)
									}
									emphasisText={companyIndex === 0 ? "$29 LLC" : null}
								>
									promotionText
								</BasePromotionText>
							</div>
						</div>

						<div className="tw:flex tw:shrink-0 tw:lg:w-[180px] tw:lg:pl-3 tw:xl:w-[212px]">
							<div className="tw:flex tw:w-full tw:flex-col tw:items-center tw:justify-center tw:lg:flex-col-reverse">
								{companyIndex === 0 ? (
									<BaseSocialProof {...styles.socialProof} />
								) : null}
								<BaseVisitLink {...styles.visitLink} icon={<RightArrowIcon />}>
									{`Visit ${company.fields.companyName}`}
								</BaseVisitLink>
							</div>
						</div>
					</div>
				</div>
			</BaseLinkWrapper>
		</Transition>
	);
};
